module.exports = __webpack_public_path__ + "static/media/ts_logo.ed9878c0.png";